import { setSessionStorage, getSessionStorage, SESSION_STORAGE_KEYS } from "./storage";
import { empty } from "./helper";
// import { FacebookPixel } from "gatsby-plugin-facebook-pixel";

/**
 * @param {string} cosmosCampaignId
 * @returns
 */
export const InitiateCheckout = async (cosmosCampaignId = "general") => {
  if (getSessionStorage(SESSION_STORAGE_KEYS.CACHE_FACEBOOK_PIXEL) === cosmosCampaignId) return;

  setSessionStorage(SESSION_STORAGE_KEYS.CACHE_FACEBOOK_PIXEL, cosmosCampaignId);

  // const id = cosmosCampaignId ?? CSRF_TOKEN;

  // console.log("facebook pixel InitiateCheckout", {
  //   content_ids: [cosmosCampaignId],
  //   eventref: ""
  // });

  if (typeof window.fbq === "undefined") return;

  // console.log("facebook pixel InitiateCheckout loaded.");

  window.fbq("track", "InitiateCheckout", {
    content_ids: [cosmosCampaignId],
    eventref: "",
  });
};

/**
 *
 * @param {*} user_email
 * @param {*} cosmosCampaignId
 * @param {*} paymentType
 * @param {*} value
 * @param {*} num_items
 * @param {*} currency
 */
export const Purchase = async (
  // user_email, //content_ids
  cosmosCampaignId = "general", // content_name
  paymentType, //content_type
  transactionID,
  value = 0,
  num_items = 1,
  currency = "AUD"
) => {
  // console.log("facebook pixel purchase event", {
  //   content_ids: [cosmosCampaignId],
  //   content_name: "Campaign: " + cosmosCampaignId,
  //   content_type: paymentType,
  //   content: transactionID,
  //   num_items: num_items,
  //   currency: currency,
  //   value: value
  // });

  // if (!FacebookPixel) return;
  if (typeof window.fbq === "undefined") return;

  // const id =
  //   cosmosCampaignId ?? getSessionStorage(WINDOW_KEYS.CSRF_TOKEN) ?? id_hash;
  window.fbq("track", "Purchase", {
    // FacebookPixel.trackCustom("Purchase", {
    content_ids: [cosmosCampaignId],
    content_name: "Campaign: " + cosmosCampaignId,
    content_type: paymentType,
    eventref: "",
    content: transactionID,
    num_items: num_items,
    currency: currency,
    value: value,
  });
};

/**
 * Saves the payment data to session storage
 * And later on we can use this to send the data to facebook pixel
 *
 * @param {*} user_email
 * @param {*} cosmosCampaignId
 * @param {*} paymentType
 * @param {*} value
 * @param {*} num_items
 * @param {*} currency
 */
export const PayPalAndApplePayPurchaseStart = async (
  user_email, //content_ids //not used but don't remove
  cosmosCampaignId = "general", // content_name
  paymentType = "PayPal", //content_type
  value = 0,
  num_items = 1,
  currency = "AUD"
) => {
  // const id_hash = await sha256(user_email);
  // const id =
  //   cosmosCampaignId ?? getSessionStorage(WINDOW_KEYS.CSRF_TOKEN) ?? id_hash;

  const paymentStartData = {
    content_ids: [cosmosCampaignId],
    content_name: "Campaign: " + cosmosCampaignId,
    content_type: paymentType,
    num_items: num_items,
    currency: currency,
    value: value,
  };

  // console.log("facebook pixel purchase event", paymentStartData);

  setSessionStorage(SESSION_STORAGE_KEYS.CACHE_FACEBOOK_PIXEL_PAYMENT_START, JSON.stringify(paymentStartData));
};

export const PayPalAndApplePayPurchase = async (transactionId) => {
  const activePaymentStart = getSessionStorage(SESSION_STORAGE_KEYS.CACHE_FACEBOOK_PIXEL_PAYMENT_START);

  if (empty(activePaymentStart)) {
    console.log("skip donation tracking event as we didn't find an active paymentStart");
    return; //skip if we can't locate a payment start in session
  }

  const paymentStartData = JSON.parse(activePaymentStart);

  if (typeof window.fbq === "undefined") return;

  // if (!FacebookPixel) return;
  window.fbq("track", "Purchase", {
    // FacebookPixel.trackCustom("Purchase", {
    ...paymentStartData,
    transactionId,
  });
};
